import { pipe } from "fp-ts/function";
import * as L from "monocle-ts/Lens";
import { AssetsTableState } from "controllers/AssetsTableController/state";

export const ColumnsL = pipe(L.id<AssetsTableState>(), L.prop("columns"));
